export const byProductCacheKey = (_state, product) => product || 'unknown'
